import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-yappy',
  templateUrl: './yappy.component.html',
})
export class YappyComponent {
  @Input( {required: true} ) visibleYappyModal!: boolean

  @Output() optionEventEmit = new EventEmitter();
  @Output() onClose = new EventEmitter<boolean>();


  closeModal(){
    this.onClose.emit(false);
  }

}
